import React from 'react';
import { Phone, MapPin, Clock, CheckCircle } from 'lucide-react';
import { firmInfoEs } from '../mockEs';
import DeftForm from '../components/DeftForm';

const ContactEs = () => {
  return (
    <div style={{ marginTop: '70px' }}>
      {/* Hero Section */}
      <section style={{
        background: 'var(--bg-card)',
        padding: '80px 0',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="heading-1" style={{ color: 'var(--brand-primary)', marginBottom: '24px' }}>
            Contáctenos
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Póngase en contacto con nuestro experimentado equipo legal. Estamos aquí para ayudarle a obtener la compensación que merece.
          </p>
        </div>
      </section>

      {/* Contact Info & Form Section */}
      <section style={{ padding: '96px 0', background: 'var(--bg-page)' }}>
        <div className="container">
          <div className="responsive-grid-contact">
            {/* Contact Information */}
            <div>
              <h2 className="heading-3" style={{ color: 'var(--brand-primary)', marginBottom: '32px' }}>
                Póngase en Contacto
              </h2>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '40px', lineHeight: '1.6' }}>
                Contáctenos hoy para una consulta gratuita. Estamos disponibles para responder sus preguntas y discutir su caso.
              </p>

              {/* Contact Details */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                {/* Phone */}
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    background: 'var(--brand-primary)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Phone size={24} color="var(--text-inverse)" />
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--text-white)', marginBottom: '8px', fontWeight: '600' }}>
                      Teléfono
                    </h4>
                    <a
                      href={`tel:${firmInfoEs.phone}`}
                      style={{
                        color: 'var(--brand-primary)',
                        textDecoration: 'none',
                        fontSize: '1.1rem',
                        fontWeight: '600'
                      }}
                    >
                      {firmInfoEs.phone}
                    </a>
                  </div>
                </div>

                {/* Address */}
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    background: 'var(--brand-primary)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <MapPin size={24} color="var(--text-inverse)" />
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--text-white)', marginBottom: '8px', fontWeight: '600' }}>
                      Dirección de la Oficina
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                      {firmInfoEs.address.full}
                    </p>
                  </div>
                </div>

                {/* Hours */}
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    background: 'var(--brand-primary)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Clock size={24} color="var(--text-inverse)" />
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--text-white)', marginBottom: '8px', fontWeight: '600' }}>
                      Horario de Oficina
                    </h4>
                    <p style={{ color: 'var(--text-secondary)' }}>
                      {firmInfoEs.hours}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form - DeftForm Embed */}
            <div className="form-container">
              <h3 className="heading-3" style={{ color: 'var(--brand-primary)', marginBottom: '24px' }}>
                Envíenos un Mensaje
              </h3>
              <DeftForm />

              {/* Garantía Sin Riesgo */}
              <div style={{
                marginTop: '24px',
                padding: '20px',
                background: 'var(--bg-card)',
                borderRadius: '8px',
                border: '1px solid var(--brand-primary)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                  <CheckCircle size={24} color="var(--brand-primary)" />
                  <strong style={{ color: 'var(--brand-primary)' }}>Garantía Sin Riesgo</strong>
                </div>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  Esta consulta es completamente gratuita y sin obligación. Trabajamos con honorarios de contingencia - no paga a menos que ganemos su caso. Su información es confidencial y está protegida por el privilegio abogado-cliente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section style={{ padding: '0 0 96px 0', background: 'var(--bg-page)' }}>
        <div className="container">
          <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '32px', textAlign: 'center' }}>
            Encuentre Nuestra Oficina
          </h2>
          <div style={{
            borderRadius: '16px',
            overflow: 'hidden',
            border: '2px solid var(--border-light)',
            height: '450px'
          }}>
            <iframe
              src={firmInfoEs.mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de LG Law Office"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactEs;
